import { render, staticRenderFns } from "./IncidentManager.vue?vue&type=template&id=2ab07e57&scoped=true"
import script from "./IncidentManager.vue?vue&type=script&lang=js"
export * from "./IncidentManager.vue?vue&type=script&lang=js"
import style0 from "./IncidentManager.vue?vue&type=style&index=0&id=2ab07e57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab07e57",
  null
  
)

export default component.exports